import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { BrowserEventService } from '@rct/lynx-lobbies-shared-lib';
import { ButtonState } from '../../../enums/button-state';

@Component({
    selector: 'lynx-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnChanges, OnInit {
  @Input() text: string;
  @Input() icon: string;
  @Input() isStatic = false;
  @Input() isDefaultDisabled = false;
  @Output() clickAction: EventEmitter<any> = new EventEmitter();
  _icon = null;
  state: ButtonState = ButtonState.Active;

  constructor(private browserEventService: BrowserEventService) {}

  ngOnChanges() {
    this._icon = this.icon;
  }

  ngOnInit() {
    this.state = this.isDefaultDisabled
      ? ButtonState.Disabled
      : ButtonState.Active;
  }

  handleOnClick() {
    if (this.isDisabled || this.isLoading) {
      return;
    }
    this.clickAction.emit();
  }

  loading() {
    this.state = ButtonState.Loading;
    this._icon = 'icon-loader';
    return {
      done: () => {
        this.state = ButtonState.Active;
        this._icon = this.icon;
      },
    };
  }

  disabled() {
    this.state = ButtonState.Disabled;
    return {
      done: () => {
        this.state = ButtonState.Active;
      },
    };
  }

  get isMobile() {
    return this.browserEventService.isMobile();
  }

  get isLoading() {
    return this.state === ButtonState.Loading;
  }

  get isDisabled() {
    return this.state === ButtonState.Disabled;
  }
}
